import React, { Fragment } from "react";
import Ball from "../../../assets/Ball.svg";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import axiosInstance from "../../../store/services/AxiosService";
import "../../../assets/css/assessment.css";
import Arrow from "../../../assets/img/Arrow";

const baseImgURL = process.env.REACT_APP_BACKEND_IMAGES2;

const IconCorrect = () => {
    return <span className="mdi mdi-check mdi-36px ml-3 p-0" style={{ color: "blue" }}></span>;
};

const IconIncorrect = () => {
    return <span className="mdi mdi-close mdi-36px ml-3 p-0" style={{ color: "red" }}></span>;
};

const ScoreBadge = ({ score }) => {
    const numScore = score === null || score === undefined ? 0 : Number(score);
    const color = numScore >= 1 ? "#28a745" : numScore > 0 ? "#e6a817" : "#dc3545";
    return (
        <span
            className="ml-3 px-2 py-1"
            style={{
                backgroundColor: color,
                color: "white",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: "bold",
                whiteSpace: "nowrap",
            }}
        >
            {numScore.toFixed(1)}/1
        </span>
    );
};

export default class ScoreAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentAnswer: null,
        };
    }

    componentDidMount() {
        this.fetchStudentAnswer();
    }

    fetchStudentAnswer() {
        const { schedule_id, student_id, url_sekolah } = this.props;
        axiosInstance
            .get(`/student_answers?schedule_id=${schedule_id}&url_sekolah="${url_sekolah}"&student_id=${student_id}`)
            .then((res) => {
                const data = res.data;
                this.setState({
                    studentAnswer: data,
                });
            })
            .catch((error) => {
                console.log(error.message);
            });
    }

    render() {
        const { studentAnswer } = this.state;

        if (studentAnswer === null) {
            return (
                <div className="text-center p-5">
                    <img src={Ball} alt="" width="100"></img>
                    <p>Memuat Rincian...</p>
                </div>
            );
        }

        return (
            <div className="card shadow mb-4 mt-4">
                <div className="card-header py-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <button className="btn btn-sm btn-light" onClick={this.props.onBack}>
                            <i className="mdi mdi-arrow-left mr-1"></i> Kembali
                        </button>
                        <div className="text-right">
                            <div className="font-weight-bolder h4 m-0">Nilai : {parseFloat(studentAnswer.student_total_scores).toFixed(2)}</div>
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    {Object.values(studentAnswer.case_parts).map((item) => (
                        <div key={item.id} className="mb-5 border-bottom pb-4">
                            <div className="mb-3">
                                <h4 className="font-weight-bold">
                                    Bagian {item.number}. {item.name}
                                </h4>
                                <div className="badge badge-outline-primary">
                                    Skor Bagian: {parseFloat(item.part_scores).toFixed(2)} / {parseInt(item.score_weight)}
                                </div>
                            </div>
                            {Object.values(item.case_questions).map((element, index) => (
                                <div key={element.id} className="mb-4 p-3 border rounded bg-white shadow-sm">
                                    <div className="d-flex mb-3">
                                        <div className="mr-2 font-weight-bold">{element.order}.</div>
                                        <div className="flex-grow-1 descript-exam" dangerouslySetInnerHTML={{ __html: element.question }}></div>
                                        <div className="ml-2">
                                            {(item.type_name === "isian singkat" || item.type_name === "uraian")
                                                ? <ScoreBadge score={element.student_answers?.[0]?.is_correct} />
                                                : (element.student_answers && element.student_answers[0] && element.student_answers[0].is_correct >= 1 ? <IconCorrect /> : <IconIncorrect />)
                                            }
                                        </div>
                                    </div>

                                    {element.file_attached && (
                                        <div className="mb-3 text-center">
                                            <Zoom>
                                                <img src={baseImgURL + element.file_attached} alt="" style={{ maxWidth: "100%", maxHeight: "300px", borderRadius: "8px" }} />
                                            </Zoom>
                                        </div>
                                    )}

                                    {/* Content based on type */}
                                    {item.type_name.includes("pilihan ganda") && (
                                        <div className="row ml-2">
                                            {Object.values(element.case_choices).map((choice) => (
                                                <div key={choice.id} className="col-md-6 mb-2">
                                                    <div className={`p-2 rounded border d-flex align-items-center ${element.student_answers[0]?.case_choice_id === choice.id ? "border-primary bg-light" : ""}`}>
                                                        <input type="radio" disabled checked={element.student_answers[0]?.case_choice_id === choice.id} className="mr-2" />
                                                        <span dangerouslySetInnerHTML={{ __html: choice.value }}></span>
                                                        {choice.is_correct === 1 && <i className="mdi mdi-check-circle text-success ml-auto"></i>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {item.type_name === "isian singkat" && (
                                        <div className="ml-3 mt-2">
                                            <p className="mb-1 text-muted small">Jawaban Siswa:</p>
                                            <div className="p-2 border rounded bg-light mb-2">
                                                {element.student_answers[0]?.answer_text || "-"}
                                            </div>
                                            <p className="mb-1 text-muted small">Kunci Jawaban:</p>
                                            <div className="p-2 border rounded text-success">
                                                {Object.values(element.case_choices)[0]?.value}
                                            </div>
                                        </div>
                                    )}

                                    {item.type_name === "uraian" && (
                                        <div className="ml-3 mt-2">
                                            <p className="mb-1 text-muted small">Jawaban Siswa:</p>
                                            <div className="p-2 border rounded bg-light mb-3" dangerouslySetInnerHTML={{ __html: element.student_answers[0]?.answer_text || "-" }}>
                                            </div>
                                            {element.student_answers[0]?.file_attached && (
                                                <div className="mb-2">
                                                    <p className="mb-1 text-muted small">Lampiran Jawaban:</p>
                                                    <Zoom>
                                                        <img src={baseImgURL + element.student_answers[0].file_attached} alt="" style={{ maxWidth: "200px", borderRadius: "4px" }} />
                                                    </Zoom>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {item.type_name === "menjodohkan" && (
                                        <ul className="list-group ml-3">
                                            {element.student_answers.map((items, idx) => (
                                                <li key={idx} className="list-group-item d-flex align-items-center justify-content-between p-2">
                                                    <div className="d-flex align-items-center">
                                                        <span dangerouslySetInnerHTML={{ __html: element.case_choices.find(c => c.id === items.case_choice_id)?.value || "" }}></span>
                                                        <Arrow className="mx-2" />
                                                        <span dangerouslySetInnerHTML={{ __html: items.answer_text }}></span>
                                                    </div>
                                                    {items.is_correct === 1 ? <IconCorrect /> : <IconIncorrect />}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                <style jsx>{`
					.badge-outline-primary {
						border: 1px solid #9a55ff;
						color: #9a55ff;
						padding: 4px 8px;
						border-radius: 4px;
					}
				`}</style>
            </div>
        );
    }
}
